import Config from "../../config/Config";
import ErrorHandler from "./errorHandler";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlDev;

const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};

const companyId = () => {
  let comp = JSON.parse(String(localStorage.getItem("company")))
  return comp.id
};

export const getSchedule = (year, callerId, day) => {
  let url = baseUrlDev + "academic/calendar/office/schedule/all?companyId=" + companyId() + "&year=" + year + "&callerId=" + callerId + "&isActive=true&day=" + day + "&page=0&size=10&sort=dayCode&dir=1"
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};

export const getAllYear = () => {
  let url = baseUrlDev + "academic/calendar/office/calendar/combo?companyId=" + companyId()
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};

export const getLessonList = () => {
  let url = baseUrlDev + "academic/calendar/office/lesson/all?companyId=" + companyId() + "&page=0&size=50&sort=lessonName&dir=1"
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};

export const getAgenda = (start, end) => {
  let url = baseUrlDev + "academic/calendar/office/calendar/agenda/all?companyId="+companyId()+"&isActive=true&startDate="+start+"&endDate="+end+"&page=0&size=100&sort=startDate&dir=1"
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        ErrorHandler(err);
        reject(err);
      });
  });
};
